// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87814915","488":"b7885101","732":"aa542499"}[chunkId] + ".chunk.js";
};